/**
 * Identifier of "areas" in the UI
 * e.g: 'Specifications' tab or 'TechnicalSpecification' component/card
 */
export enum Area {
  /** TAB: Specifications */
  Specifications = 'Specifications',
  Planning = 'Planning',
  Materials = 'Materials',
  Teamcenter = 'Teamcenter',
  PartDesign = 'Part Design',
  MCodes = '2D M-Codes',
  /** COMPONENT: Technical specification */
  TechnicalSpecification = 'Technical specification',
  TechnicalSpecificationOperation = 'Operation',
  TechnicalSpecificationCharacteristics = 'Characteristic',
  /** COMPONENT: Development Milestones */
  DevelopmentMilestones = 'Development Milestones',
  DevelopmentMilestonesCode = 'Code',
  /** COMPONENT: MaterialBomComponent */
  MaterialBom = 'Material BOM',
  Oqc = 'OQC',
}
